import { getSport } from "@/sports";
import { playerRoutes, routeTiming, snapTime, uid } from "@/lib/playEngine";

const r1 = (v) => Math.round(v * 10) / 10;
const frame = (play, p) => ({ fwd: p.side === "offense" ? -1 : 1, inward: p.x < getSport(play.sport).centerX ? 1 : -1 });

// Store routes as forward / toward-the-middle yards so they fit any player on either side.
export function toLibrary(play, player) {
  const { fwd, inward } = frame(play, player);
  const snap = snapTime(play);
  return playerRoutes(play, player.id).map((r) => ({
    type: r.type, curve: r.curve || "sharp", rel_start: r1(r.start - snap), duration: r.duration,
    points: r.points.map((q) => ({ f: r1((q.y - player.y) * fwd), lat: r1((q.x - player.x) * inward), pause: q.pause || 0, dur: q.dur || null })),
  }));
}

export function fromLibrary(play, player, segments) {
  const { fwd, inward } = frame(play, player);
  const snap = snapTime(play);
  return segments.map((s) => ({
    id: uid("r"), player_id: player.id, type: s.type, curve: s.curve, start: Math.max(0, r1(snap + s.rel_start)), duration: s.duration, auto_time: false,
    points: s.points.map((q) => ({ x: r1(Math.min(52.8, Math.max(0.5, player.x + q.lat * inward))), y: r1(player.y + q.f * fwd), pause: q.pause || 0, dur: q.dur || null })),
  }));
}

export const libraryLength = (segments) => segments.reduce((n, s) => n + s.points.length, 0);
export { routeTiming };
